import { IconButton, Menu, MenuItem } from "@mui/material";
import { DeleteIcon, EditIcon, ThreedotIcon } from "app/icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useStyles } from "./styles";

type Props = {
  onEdit?: () => void;
  onDelete?: () => void;
};

const CardActionsMenu = ({ onEdit, onDelete }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const closeMenu = () => setMenuAnchor(null);

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setMenuAnchor(event.currentTarget);
  };

  const handleEdit = () => {
    onEdit?.();
    closeMenu();
  };

  const handleDelete = () => {
    onDelete?.();
    closeMenu();
  };

  return (
    <>
      <IconButton
        size="small"
        className={`${styles.iconButton}${
          menuAnchor ? ` ${styles.iconButtonOpen}` : ""
        }`}
        aria-label={t("CUSTOMERS.DETAILS.ACTIONS.MENU")}
        onClick={openMenu}
      >
        <ThreedotIcon />
      </IconButton>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={closeMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        classes={{ paper: styles.menuPaper }}
        disableScrollLock
      >
        <MenuItem className={styles.menuItem} onClick={handleEdit}>
          <span className={styles.menuItemLabel}>
            {t("CUSTOMERS.DETAILS.ACTIONS.EDIT")}
          </span>
          <span className={styles.menuItemIcon} aria-hidden>
            <EditIcon width={20} height={20} />
          </span>
        </MenuItem>
        <MenuItem className={styles.menuItem} onClick={handleDelete}>
          <span className={styles.menuItemLabel}>
            {t("CUSTOMERS.DETAILS.ACTIONS.DELETE")}
          </span>
          <span className={styles.menuItemIcon} aria-hidden>
            <DeleteIcon width={20} height={20} />
          </span>
        </MenuItem>
      </Menu>
    </>
  );
};

export default CardActionsMenu;
